<template>
  <div class="add-basic-information" style="overflow:auto">
    <div class="add-title">
      <span class="basic title-font-style">{{title}}</span>
    </div>
    <div class="block infinite-list-wrapper" style="overflow:auto;padding:9px 0 0 12px">
      <el-timeline v-infinite-scroll="load" infinite-scroll-disabled="disabled">
        <el-timeline-item
          class="infinite-list-item"
          v-for="(activity, index) in list"
          :key="index"
          :type="activity.type"
          :color="activity.color"
          :size="activity.size"
        >
          <el-row>
            <el-col :span="3">
              <span
                style="padding-left:30px;;min-width: 140px; width: 140px;"
              >{{activity.createDate|dateFilter}}</span>
            </el-col>
            <el-col :span="2">
              <span style="padding-left:30px;">
                <el-tooltip
                  :disabled="activity.createUser.length < 4"
                  class="item"
                  effect="dark"
                  :content="activity.createUser"
                  placement="top-start"
                >
                  <div
                    style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;min-width: 80px;width: 80px;"
                  >{{activity.createUser}}</div>
                </el-tooltip>
              </span>
            </el-col>
            <el-col :span="16">
              <span style="padding-left:30px">{{activity.optContent}}</span>
            </el-col>
          </el-row>
        </el-timeline-item>
        <p v-if="loading">加载中......</p>
        <p v-if="noMore">没有更多了</p>
      </el-timeline>
    </div>
  </div>
</template>

<script>
import {
  queryPageAllOperation,
  queryPageAllBySuaId
} from '@/api/system/rightsManagement'
import { formatDate } from '@/util/tool'
export default {
  props: ['id'],
  data () {
    return {
      total: 0,
      currentPage: 1, // 当前页
      pageSize: 10, // 分页页数
      list: [],
      loading: false,
      noMore: false,
      title: '操作日志'
    }
  },
  mounted () {
    this.getOperation()
  },
  computed: {
    disabled () {
      return this.loading || this.noMore
    }
  },
  methods: {
    // 日志不带流程功能组件,需要带流程功能换另一个组件叫operationLogAndFlow
    // 获取操作日志
    getOperation () {
      if (this.$route.path === '/crm/supplier/activityEdit') {
        // crm供应商管理活动详情
        this.getAllOperationById('supplierEditActivity', this.id)
      } else if (this.$route.path === '/product/productManage/productDetails') {
        // 产品管理产品详情
        this.getAllOperationById('product-manager', this.id)
      } else if (
        this.$route.path === '/sell/personageManagement/sellInquiryDetails'
      ) {
        // 销售产品询价
        this.title = '工单日志'
        this.getAllOperationById('orderBase_edit', this.$route.query.id)
      } else if (
        this.$route.path ===
        '/sell/personageManagement/collectionApplicationDetails'
      ) {
        // 收款申请详情
        this.title = '工单日志'
      } else if (this.$route.path === '/finance/financeManage/acceplist') {
        // 可用汇票详情
        this.title = '工单日志'

        this.getAllOperationById('financeAcceptanceBillService', this.id)
      } else if (
        this.$route.path === '/finance/financeManage/collectionDetails'
      ) {
        // 可用汇票详情
        this.title = '工单日志'

        this.getAllOperationById('financeAcceptanceBill', this.id)
      } else if (this.$route.path === '/finance/financeManage/auditDetails') {
        this.title = '工单日志'

        this.getAllOperationById('financeAcceptanceBill', this.id)
      } else if (this.$route.path === '/finance/financeManage/dealList') {
        this.title = '工单日志'

        this.getAllOperationById('financeAcceptanceBill', this.id)
      } else if (this.$route.path === '/finance/financeManage/dealwith') {
        this.title = '工单日志'

        this.getAllOperationById('financeAcceptanceBill', this.id)
      }
    },

    // 不带id页面初始化
    getAllOperation (type) {
      queryPageAllOperation(this.currentPage, this.pageSize, type)
        .then((res) => {
          if (res.data.code === 200) {
            this.list = res.data.obj.records
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 带id页面初始化
    getAllOperationById (type, id, data) {
      if (data !== undefined) {
        this.currentPage = 1
      }
      queryPageAllBySuaId(type, id, this.currentPage, this.pageSize)
        .then((res) => {
          if (res.data.code === 200) {
            this.list = res.data.obj.records
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 加载更多
    load () {
      this.loading = true
      setTimeout(() => {
        if (this.$route.path === '/crm/supplier/activityEdit') {
          // 活动详情
          this.getAllOperationLoadById('supplierEditActivity', this.id)
        } else if (
          this.$route.path === '/sell/personageManagement/sellInquiryDetails'
        ) {
          // 销售产品询价
          this.getAllOperationLoadById('orderBase_edit', this.$route.query.id)
        } else if (
          this.$route.path === '/product/productManage/productDetails'
        ) {
          // 产品详情
          this.getAllOperationLoadById('product-manager', this.id)
        } else if (this.$route.path === '/finance/financeManage/acceplist') {
          // 销售产品询价
          this.getAllOperationLoadById('financeAcceptanceBillService', this.id)
        } else if (
          this.$route.path === '/finance/financeManage/collectionDetails'
        ) {
          this.getAllOperationLoadById('financeAcceptanceBill', this.id)
        } else if (this.$route.path === '/finance/financeManage/auditDetails') {
          this.getAllOperationLoadById('financeAcceptanceBill', this.id)
        } else if (this.$route.path === '/finance/financeManage/dealList') {
          this.getAllOperationById('financeAcceptanceBill', this.id)
        } else if (this.$route.path === '/finance/financeManage/dealwith') {
          this.getAllOperationById('financeAcceptanceBill', this.id)
        }
      }, 1000)
    },
    // 滚动加载更多不带id
    getAllOperationLoad (type) {
      queryPageAllOperation((this.currentPage += 1), this.pageSize, type)
        .then((res) => {
          if (res.data.code === 200) {
            const arrList = res.data.obj.records
            if (res.data.obj.records.length < 10) {
              this.noMore = true
            }
            this.list = this.list.concat(arrList)
            this.loading = false
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 滚动加载更多不带id
    getAllOperationLoadById (type, id) {
      queryPageAllBySuaId(type, id, (this.currentPage += 1), this.pageSize)
        .then((res) => {
          if (res.data.code === 200) {
            const arrList = res.data.obj.records
            if (res.data.obj.records.length < 10) {
              this.noMore = true
            }
            this.list = this.list.concat(arrList)
            this.loading = false
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (!time) {
    return ''
  }
  return formatDate(new Date(time), 'yyyy-MM-dd hh:mm')
}
</script>

<style lang="scss" scoped>
.block {
  padding: 10px 0 0 20px;
}
.infinite-list-item {
  font-size: 0;
  span {
    font-size: 14px;
    vertical-align: middle;
  }
}
</style>
